export interface IBets {
  legs: number;
  betTypeName: string;
  odds: number;
  payout: number;
  ticketNumber: string;
  market: string;
  id: string;
  headerDateTime: string;
  totalPages: number;
  status: string;
  isExotic: boolean;
  stake: number;
  cashoutAmount?: number;
  canCashOut: boolean;
  times?: number;
  betTitleId?: number;
  isLuckyPick: boolean;
}

export interface IBetTypes {
  betType: string;
  totalStake: number;
  totalPayout: number;
  bets: IBets[];
}

export interface IBetLegs {
  legNumber: number;
  odd: number;
  legDate: string;
  eventDetail: string;
  eventName: string;
  market: string;
  status: string;
  isInPlay: boolean;
}

export interface IMyBets {
  openBets: IBetTypes[];
  allSettledBets: IBetTypes[];
  winBets: IBetTypes[];
  lossBets: IBetTypes[];
  betLegs: IBetLegs[];
  isFetchingMyBets: boolean;
  noBetsFound: boolean;
  isFetchingBetLegs: boolean;
}

export const myBetsInitialState: IMyBets = {
  openBets: [],
  allSettledBets: [],
  winBets: [],
  lossBets: [],
  betLegs: [],
  isFetchingMyBets: false,
  noBetsFound: false,
  isFetchingBetLegs: false
};

export type TMyBetsResponse = {
  responseObject: IBetTypes[];
  filterType: number;
};

export type TGetBetLegsRequest = {
  betId: number;
};

export type TGetBetLegsResponse = {
  betLegs: IBetLegs[];
  responseStatus: number;
  responseMessage: string;
  responseMessageDetail: string;
};
